export default __webpack_public_path__ + "static/media/densified-fiber-filling-material.7287de3e.webp";